import { Modal, Text, Button, Group, MantineSize } from "@mantine/core";
import { ReactNode } from "react";

interface ButtonConfig {
  label: string;
  onClick: () => void;
  variant?: "default" | "filled" | "outline" | "subtle";
  color?: string;
  loading?: boolean;
}

interface GenericModalProps {
  disclosure: [boolean, { open: () => void; close: () => void; toggle: () => void }];
  title: string;
  subtitle?: string;
  buttons?: ButtonConfig[];
  children?: ReactNode;
  size?: MantineSize | (string & {}) | number;
  justifyButtons?: React.CSSProperties["justifyContent"];
  padding?: MantineSize | (string & {}) | number;
  closeButtons?: boolean;
}

export default function GenericModal({
  disclosure,
  title,
  subtitle,
  buttons = [], // Default to empty array if not provided
  children,
  size = "md",
  justifyButtons = "flex-end",
  padding = "md",
  closeButtons = true,
}: GenericModalProps) {
  const [opened, { close }] = disclosure;

  return (
    <Modal
      opened={opened}
      onClose={close}
      title={title}
      centered
      size={size}
      padding={padding}
      withCloseButton={closeButtons}
      closeOnClickOutside={true}
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 0.5,
      }}
      fw={400}
      fz={18}
    >
      {subtitle && (
        <Text fz={14} c="slate.6" mb={children ? "md" : "xl"}>
          {subtitle}
        </Text>
      )}

      {children}

      {buttons.length > 0 && (
        <Group justify={justifyButtons} gap="md" mt={children ? "lg" : 0}>
          {buttons.map((button, index) => (
            <Button
              key={index}
              variant={button.variant || "default"}
              color={button.color || "primary"}
              onClick={button.onClick}
              loading={button.loading}
            >
              {button.label}
            </Button>
          ))}
        </Group>
      )}
    </Modal>
  );
}
